import { useEffect, useState } from "react";

import { ITicketCampaign } from "../types";

interface IProps {
  campaign: ITicketCampaign;
  onClose: () => void;
}

export function CampaignDescriptionModal({ campaign, onClose }: IProps) {
  const [animate, setAnimate] = useState(false);

  function handleClose() {
    setAnimate(false);
    setTimeout(() => onClose(), 300);
  }

  useEffect(() => {
    setTimeout(() => setAnimate(true), 10);

    function handleEscapeClose() {
      setAnimate(false);
      setTimeout(() => onClose(), 300);
    }

    function handleEscape(evt: KeyboardEvent) {
      if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
        handleEscapeClose();
      }
    }

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  return (
    <>
      <div
        className={`modal fade ${animate ? "show" : ""}`}
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <h5 className="modal-title fw-bold mb-1">{campaign.name}</h5>
                <small className="text-muted">
                  {campaign.key} • {campaign.campaign}
                </small>
              </div>
              <button
                type="button"
                className="btn-close"
                aria-label="Fechar"
                onClick={handleClose}
              />
            </div>
            <div className="modal-body">
              <p className="mb-0">{campaign.description_short}</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={`modal-backdrop fade ${animate ? "show" : ""}`}></div>
    </>
  );
}
